import { useTranslation } from "react-i18next";

import { Col, ConfigProvider, DatePicker, Flex, Modal, Row, Select, Space } from "antd";
import enUS from "antd/es/locale/en_US";
import thTh from "antd/es/locale/th_TH";
import TableAntd from "components/elements/Table/Table";
import EmployeeEmploymentMovementTable from "components/table/EmployeeEmploymentMovementTable";
import dayjs from "dayjs";
import StatusTag from "components/elements/TagCustom/StatusTag";

import customParseFormat from 'dayjs/plugin/customParseFormat';
import i18n from "i18n";
import { Card, Tabs } from "antd/lib";
import { useCallback, useEffect, useMemo, useState } from "react";
import { MY_REQUEST_TYPE } from "../schemas/movementSchema";
import * as services from "../services/employeeApi";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from 'react-router-dom';



import { dataURLtoFile, generateRandomString } from "utils/helper";



function formatDateTime(dateString) {
  if (!dateString) return;
  const date = dayjs(dateString);
  return date.format(i18n.language === "en" ? "DD/MM/YYYY HH:mm" : `DD/MM/${date.year() + 543} HH:mm`);
}

function formatDate({ dateString, pattern = "YYYY-MM-DD", reFormat = "DD-MM-YYYY" }) {
  if (!dateString) return;
  const date = dayjs(dateString, pattern);
  return date.format(reFormat);
}

function EmployeeEmploymentMovement({
  isLoading = true,
  isModalOpen = false,
  isMovement = [],
  movementList = [],
  movementGroupOptions = [],
  pagination = {},
  onRowClick = () => { },
  onSubmitModal = () => { },
  selectedRow = [],
  setSelectedRow = () => { },
  onChange = () => { },
  transformData = () => { },
  onCancel = () => { },
  selecttable = () => { },
  setModalOpen = () => { },
  setMovement = () => { },
  onExpenseDateChange = () => { },
  onMovementGroupChange = () => { },
  onRowDelete = () => { },
  getTableData = () => { },
}) {
  const { t, i18n } = useTranslation();

  const params = useParams();
  const currentCompany = useSelector((state) => state.company.currentCompany);
  const [useCurrentMenu, setCurrentMenu] = useState(MY_REQUEST_TYPE.DETAIL);
  const [selectedMenu, setMenu] = useState(MY_REQUEST_TYPE.DETAIL);
  const [openListEmployee, setOpenListEmployee] = useState(false);
  const [listEmployees, setListEmployees] = useState({});
  const [currentWorkflow, setCurrentWorkflow] = useState([]);
  dayjs.extend(customParseFormat);
  dayjs.locale('th');
  let language = i18n.language === 'en' ? "En" : ""



  const handleMenuChange = useCallback(
    (e) => {
      setMenu(e);
    },
    [setMenu]
  );

  function getItem(label, key,) {
    return {
      label: label,
      key: key,
    };
  }

  const MENU = [
    getItem(t("leave_type.label.detail"), MY_REQUEST_TYPE.DETAIL),
    getItem(t("leave_type.label.approvalSequence"), MY_REQUEST_TYPE.APPROVALSEQ),

  ];



  const getWorkflow = (async ({ flowRequestId = "" }) => {
    let data = [];

    data = await services.getWorkflowByRequestId({
      requestId: generateRandomString(),
      companyId: currentCompany,
      employeeId: params?.id,
      flowRequestId: flowRequestId,
    });
    setCurrentWorkflow(data?.data?.approvalSequence)

  })



  const columns = [
    {
      title: <div className="text-table">{t("employment.label.no")}</div>,
      dataIndex: "index",
      key: "index",
      width: 150,
    },
    {
      title: <div className="text-table">{t("employment.label.movement_fild")}</div>,
      dataIndex: "field",
      key: "field",
      render: (_, record) => {
        return (
          <div>
            {t(`movementfield.${record?.field?.toLowerCase()}`, {
              defaultValue: record?.field.toLowerCase(),
            })}
          </div>
        );
      },
      width: 200,
    },
    {
      title: <div className="text-table">{t("employment.label.old_value")}</div>,
      dataIndex: "oldValue",
      key: "oldValue",
      width: 200,
      render: (text) => {
        if (typeof text === "string" && /^"\d{1,3}(,\d{3})*\.\d{2}"$/.test(text)) {
          return text.replace(/"/g, "");
        }
        return text;
      },
    },
    {
      title: <div className="text-table">{t("employment.label.new_value")}</div>,
      dataIndex: "newValue",
      key: "newValue",
      width: 200,
      render: (text) => {
        if (typeof text === "string" && /^"\d{1,3}(,\d{3})*\.\d{2}"$/.test(text)) {
          return text.replace(/"/g, "");
        }
        return text;
      },
    },
  ];



  return (
    <Space style={{ width: "100%" }} size={24} direction="vertical">
      {/* <Row justify="end"> */}
      <Flex gap={8} justify="end">
        <ConfigProvider locale={i18n.language == 'en' ? enUS : thTh}>
          <DatePicker
            name="expenseDate"
            style={{ width: '130px', height: '43px' }}
            format="MMMM"
            placeholder={t('employment.label.month')}
            size="large"
            picker="month"
            onChange={onExpenseDateChange}
          />
        </ConfigProvider>
        <Select
          options={movementGroupOptions}
          style={{ width: '200px', height: '43px' }}
          name="movementGroup"
          // label={t("address.subdistrict") + t("common.required_field_suffix")}
          placeholder={t('employment.label.type')}
          size="large"
          // defaultValue={movementGroupOptions.length > 0 ? movementGroupOptions[0].value : undefined}
          onChange={onMovementGroupChange}
        />
        {/* <Dropdown
            menu={{
              items: EMPLOYEE_EMPLOYMENT_MOVEMENT_OPTIONS.map((opt) => ({
                key: opt.value,
                label: (
                  <Space onClick={() => onSelect(opt.value)}>
                    {i18n === "en" ? opt.labelEn : opt.label}
                  </Space>
                ),
              })),
            }}
            trigger={["click"]}
          >
            <Button onClick={(e) => e.preventDefault()}>
              {t("common.create")} <PlusOutlined />
            </Button>
          </Dropdown> */}
      </Flex>
      {/* </Row> */}
      {/* <CardContainer width="100%" height="fit-content"> */}
      <Modal
        title={t("employment.label.movement")}
        open={isModalOpen}
        onCancel={() => {
          setModalOpen(false);
          setSelectedRow(null);
        }}
        width="1000px"
        footer={null}
      >


        <Tabs items={MENU} onChange={(e) => { handleMenuChange(e); setCurrentMenu(e); }} />

        {(selectedMenu === MY_REQUEST_TYPE.DETAIL) && (
          <><Row gutter={[16, 16]} style={{ marginBottom: "16px" }}>
            <Col span={24}>
            </Col>
            <Col span={12}>
              <span>{t("document.number")}: <strong>{selectedRow?._id || "-"}</strong></span>
            </Col>
            <Col span={12}>
              <span>{t("document.create_date")}: <strong>{formatDate({ dateString: selectedRow?.createDate, reFormat: i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB" })}</strong></span>
            </Col>
            <Col span={12}>
              <span>{t("document.created_by")}: <strong>{i18n.language === "en" ? selectedRow?.createBy?.nameEn : selectedRow?.createBy?.name} {i18n.language === "en" ? selectedRow?.createBy?.surNameEn : selectedRow?.createBy?.surName}</strong></span>
            </Col>
            <Col span={12}>
              <span>{t("document.effective_date")}: <strong>{formatDate({ dateString: selectedRow?.effectiveDate, reFormat: i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB" })}</strong></span>
            </Col>

            {/* <Col span={12}>
          {selectedRow?.approveStatusEn === "Approved" ? (
            <span>{t("document.approved_date")}: <strong>{selectedRow?.approveDate !== 'null' ? formatDate({ dateString: selectedRow?.approveDate, reFormat: i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB" }) : formatDate({ dateString: selectedRow?.approveDate, reFormat: i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB" })}</strong></span>
          ) : (
            <span>{t("document.approved_date")}: <strong>-</strong></span>
          )}
        </Col> */}

            <Col span={12}>
              <span>{t("document.type")}: <strong>{i18n.language === "en" ? selectedRow?.movementTypeNameEn : selectedRow?.movementTypeName}</strong></span>
            </Col>
            {/* <Col span={12}>
          <span>{t("document.approved_by")}:
            <strong>
              {selectedRow?.timeline
                ?.filter(item => item.approveStatusEn === "Approved")
                .map((item, index) => (
                  <div key={index}>
                    {t("document.approver_number")} {index + 1} :
                    {i18n.language === "en"
                      ? `${item.employee.nameEn} ${item.employee.surNameEn}`
                      : `${item.employee.name} ${item.employee.surName}`}
                  </div>
                ))}
            </strong>
          </span>
        </Col> */}
          </Row>



            {selectedRow ? (
              <TableAntd
                dataSource={selecttable}
                columns={columns}
                pagination={false}
                bordered
              />
            ) : (
              <p>{t("common.no_data")}</p>
            )}

          </>)}



        {selectedMenu === MY_REQUEST_TYPE.APPROVALSEQ && (
          <>
            {Array.isArray(currentWorkflow) &&
              currentWorkflow?.map((workflow, index) => (
                <>
                  <label>{`${t('leave_type.label.sequence')} ${index + 1}`}</label>
                  <Card size="small" key={index} style={{ border: "1px solid #000" }}>
                    <Row>
                      <Col span={16}>
                        <label style={{ color: "#667085" }}>{`${t('leave_type.label.approver')}`}</label>
                      </Col>
                      <Col span={8}>
                        <span style={{ color: "#667085", display: "flex", justifyContent: "flex-end" }}>{t("leave_type.label.approvalDate")}</span>
                      </Col>
                      <Col span={16}>
                        <span>{workflow?.listEmployees?.slice(0, 3).join(" , ")}</span>
                        <> </>
                        {workflow?.listEmployees?.length > 3 ? (
                          // eslint-disable-next-line jsx-a11y/anchor-is-valid
                          <a
                            onClick={() => {
                              setOpenListEmployee(true);
                              setListEmployees(workflow?.listEmployees);
                            }}
                            style={{
                              display: "inline-block",
                              borderRadius: "36px",
                              padding: "4px 12px",
                              fontSize: "0.7vw",
                              color: "#fff",
                              background: "var(--primary-color)",
                              textDecoration: "none",
                              fontWeight: "bold",
                              border: "1px solid var(--primary-color)",
                              cursor: "pointer"
                            }}

                          >
                            {`+ ${workflow?.listEmployees?.length - 3} ...`}
                          </a>
                        ) : ""}
                      </Col>
                      <Col span={8}>
                        <span style={{ display: "flex", justifyContent: "flex-end" }}>{workflow?.approveDate ? formatDateTime(workflow?.approveDate) : "-"}</span>
                      </Col>
                    </Row>
                    <Row >
                      <Col span={16} style={{ marginTop: '10px' }}>
                        <label>
                          {workflow?.workFlowtype}
                        </label></Col>
                      <Col span={8} style={{ marginTop: '10px' }} >
                        <label style={{ display: "flex", justifyContent: "flex-end" }}> <StatusTag value={(workflow?.["approveStatus" + language])} /> </label>
                      </Col>
                    </Row>
                  </Card >
                </>
              ))}
          </>
        )}


        {openListEmployee && (
          <Modal title={t("leave_type.label.approver")}
            open={openListEmployee}
            onCancel={() => setOpenListEmployee(false)}
            footer={false}
            width="510px"
            maskClosable={false}
          >
            <Card size="small" style={{ border: "1px solid #000" }}>
              {listEmployees?.map((employee, index) => (
                <label key={index}>
                  {employee}
                  <br />
                </label>
              ))}
            </Card>
          </Modal>
        )}
      </Modal>
      <EmployeeEmploymentMovementTable
        isLoading={isLoading}
        movementList={movementList}
        pagination={pagination}
        onChange={onChange}
        onRowClick={onRowClick}
        onRowDelete={onRowDelete}
        getWorkflow={getWorkflow}
      />
      {/* </CardContainer> */}
    </Space>
  );
}

export default EmployeeEmploymentMovement;
